import { render, staticRenderFns } from "./firebaseBackups.vue?vue&type=template&id=eb138616&scoped=true"
import script from "./firebaseBackups.vue?vue&type=script&lang=js"
export * from "./firebaseBackups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb138616",
  null
  
)

export default component.exports